import { slug } from '@magalu/mixer-utils';
var getFormatType = function getFormatType(type) {
  var typeMap = {
    "default": 'icone:',
    subsection: 'conheça-tambem:'
  };
  return typeMap[type] || typeMap["default"];
};
var generateContentId = function generateContentId(content, category) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var formatType = type !== 'departamento' ? getFormatType(type) : '';
  return "".concat(slug(content), ":").concat(formatType).concat(slug(category));
};
var selectContent = function selectContent(content, category) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return {
    content_id: generateContentId(content, category, type) || null,
    content_type: 'menu-superior',
    event: 'select_content'
  };
};
export default selectContent;